import { GET_ANIMAL_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ANIMAL_TYPES_SUCCESS: {
      const animalTypes = action.payload;

      if (!animalTypes){
        return [...state];
      }

      return [
        ...state,
        ...animalTypes
      ]
    }
    default:
      return state;
  }
}
